export default __webpack_public_path__ + "static/earth-e085cc607af677d4dec653e2759545fd.png";